<template>
  <div>
    <connection-opened :channel="publicChannel" />
    <connection-closed :channel="publicChannel" />
    <message-created :channel="privateChannel" />

    <slot v-if="subscribed"></slot>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import ConnectionOpened from './connection-opened'
  import ConnectionClosed from './connection-closed'
  import MessageCreated from './message-created'

  const { mapState } = createNamespacedHelpers('conference')
  let publicChannelName
  let privateChannelName

  export default {
    components: {
      ConnectionOpened,
      ConnectionClosed,
      MessageCreated
    },
    data () {
      return {
        publicChannel: null,
        publicChannelSubscribed: false,
        privateChannel: null,
        privateChannelSubscribed: false
      }
    },
    computed: {
      ...mapState([
        'activity'
      ]),
      subscribed () {
        return this.publicChannelSubscribed && this.privateChannelSubscribed
      }
    },
    created () {
      this.registerPusher()
    },
    beforeDestroy () {
      this.$pusher.unsubscribe(publicChannelName)
      this.$pusher.unsubscribe(privateChannelName)
    },
    methods: {
      registerPusher () {
        publicChannelName = `activity.${this.activity.id}`
        privateChannelName = `private-activity.${this.activity.id}`

        this.publicChannel = this.$pusher.subscribe(publicChannelName)
        this.privateChannel = this.$pusher.subscribe(privateChannelName)

        this.publicChannel.bind('pusher:subscription_succeeded', () => (this.publicChannelSubscribed = true))
        this.privateChannel.bind('pusher:subscription_succeeded', () => (this.privateChannelSubscribed = true))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// with-pusher-subscription.vue?41128dde